//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { ContentSourceProductReview } from '@apis/campaigns/contentSourceApiModel';
import { isDefined } from '@utils/filterPredicates';
import { Serialized } from '@utils/types/Serialized';

export const deserializeContentSourceProductReview = (
  review: Serialized<ContentSourceProductReview>,
): ContentSourceProductReview => {
  const { submissionTime, ...rest } = review;
  return {
    ...rest,
    ...(isDefined(submissionTime)
      ? {
          submissionTime: new Date(submissionTime),
        }
      : {}),
  };
};
